<template>
  <page-view :aside="aside" class="page-view">
    <template #header>
      <base-header
        class="base-header"
        title="Live"
        :subtitle="video.title"
        @title="handleBackToListing"
        @back="handleBackToListing"
      >
        <template #actions>
          <v-col
            style="display: contents"
            v-if="liveStatus === 'online'"
            cols="12"
            class="mb-0 pb-0 px-0"
          >
            <v-btn
              :disabled="loadings.endLive"
              :loading="loadings.endLive"
              color="primary"
              outlined
              @click="handleEndLive"
              >{{ $t('message.pages.newLive.endLive') }}</v-btn
            >
          </v-col>
          <v-col
            style="display: contents"
            v-if="liveStatus === 'finished_imported'"
            cols="12"
            class="mb-0 pb-0 px-0"
          >
            <v-btn
              :disabled="loadings.endLive"
              :loading="loadings.endLive"
              color="primary"
              outlined
              @click="handleOpenVideo"
              >{{ $t('message.pages.newLive.openVideo') }}</v-btn
            >
          </v-col>

          <v-col
            style="display: contents"
            v-if="
              liveStatus === 'offline' &&
              scheduled_at !== null &&
              isAfterScheduled == false
            "
            cols="12"
            class="mb-0 pb-3 px-0"
          >
            <v-btn
              class="mr-3"
              :disabled="loadings.endLive"
              :loading="loadings.endLive"
              color="red"
              outlined
              @click="scheduledCheck"
              >{{ $t('message.pages.newLive.cancelLive') }}</v-btn
            >
            <v-btn
              :disabled="loadings.endLive"
              :loading="loadings.endLive"
              color="primary"
              outlined
              @click="startLive"
              >{{ $t('message.pages.newLive.startNow') }}</v-btn
            >
          </v-col>
        </template>
      </base-header>
    </template>

    <template #content>
      <div v-if="loading">
        <v-skeleton-loader
          type="image"
          height="100%"
          width="100%"
        ></v-skeleton-loader>
        <v-skeleton-loader
          type="image"
          height="100%"
          width="100%"
        ></v-skeleton-loader>
        <v-skeleton-loader
          type="image"
          height="100%"
          width="100%"
        ></v-skeleton-loader>
      </div>

      <div v-else class="new-live__container" style="max-width: 100%">
        <!-- player -->
        <template>
          <span
            v-if="
              isOffline && (scheduled_at == null || isAfterScheduled == true)
            "
            class="new-live__player is-waiting"
          >
            <div
              v-if="!loading"
              class="player-waiting player-content mt-15 mb-15"
              style="
                height: 262px;
                width: 488px;
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <div>
                <v-icon
                  class="mr-3"
                  style="color: var(--v-brand-lighten2); font-size: 100px"
                >
                  mdi-video-box
                </v-icon>

                <h1 class="page-label-title">
                  {{ $t('message.pages.live.startTransmition') }}
                </h1>
                <p class="page-label-text">
                  {{ $t('message.pages.live.transmitionDescription') }} <br />
                  {{ $t('message.pages.live.transmitionDescription2') }}
                </p>
              </div>
            </div>
          </span>

          <span
            v-if="
              isOffline && scheduled_at !== null && isAfterScheduled == false
            "
            class="new-live__player is-waiting"
          >
            <div
              class="mt-15 mb-15"
              style="
                height: 262px;
                width: 488px;
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <div
                style="
                  background-color: black;
                  opacity: 59%;
                  padding: 8px 24px 8px 24px;
                  border-radius: 60px;
                "
              >
                <span style="color: white">
                  {{ $t('message.pages.newLive.liveStartIn') }} <br />
                  {{ timeToStart }}
                </span>
              </div>
            </div>
          </span>
          <!-- converting -->

          <!-- finish -->

          <!-- streaming -->
          <span
            v-if="
              isOnline ||
              liveStatus === 'finished' ||
              liveStatus === 'finished_imported'
            "
            class="is-streaming"
            v-html="embedPageGet()"
          />
        </template>

        <!-- player :: data -->
        <div class="new-live__data">
          <span
            v-if="
              isOffline && (scheduled_at == null || isAfterScheduled == true)
            "
            class="new-live__data--status pr-2 pl-2 offlineStatus"
            style="background-color: #ebedff; border-radius: 30px; padding: 3px"
          >
            {{ notCreated ? 'OFFLINE' : liveStatus }}
          </span>

          <span
            v-if="liveStatus === 'online'"
            class="new-live__data--status pr-2 pl-2"
            style="
              background-color: #ffcdd2;
              color: #f44336;
              border-radius: 30px;
              padding: 3px;
            "
          >
            <span
              class="circle"
              style="background-color: #ff5252; float: left"
            />
            LIVE
          </span>

          <span
            v-if="liveStatus === 'finished'"
            class="new-live__data--status pr-2 pl-2"
            style="
              background-color: #d8d6d6;
              color: grey;
              border-radius: 30px;
              padding: 3px;
            "
          >
            <span
              class="circle"
              style="
                background-color: grey;
                float: left;
                animation: provisioning 1.2s infinite;
              "
            />
            {{ $t('message.converting') }}...
          </span>
          <span
            v-if="liveStatus === 'finished_imported'"
            class="new-live__data--status pr-2 pl-2"
            style="
              background-color: #d8d6d6;
              color: grey;
              border-radius: 30px;
              padding: 3px;
            "
          >
            <span class="circle" style="background-color: grey; float: left" />
            {{ $t('message.pages.live.finished') }}
          </span>
          <span
            v-if="
              liveStatus === 'offline' &&
              scheduled_at !== null &&
              isAfterScheduled == false
            "
            class="new-live__data--status pr-2 pl-2"
            style="
              background: #ebedff;
              color: rgb(0, 0, 0);
              border-radius: 30px;
              padding: 3px;
            "
          >
            {{ $t('message.pages.newLive.scheduled') }}
          </span>

          <!-- <span v-if="!isOnline" class="new-live__data--status pr-2 pl-2" style="background-color: #EBEDFF; border-radius: 30px; padding: 3px;">
            {{ notCreated ? 'OFFLINE' : liveStatus }}
          </span> -->
          <v-scroll-x-transition mode="out-in" hide-on-leave>
            <v-card
              v-if="!isStreamingRightNow && value === 1"
              flat
              tile
              class="d-flex flex-column"
            >
              <live-metrics
                :isStreamingRightNow="isStreamingRightNow"
                :serverStatus="serverStatus"
                :liveStatus="liveStatus"
                :timeLeft="timeLeft"
                :errors="errors"
                :liveInfo="liveInfo"
                :lastVerificationServer="lastVerificationServer"
                :isLive="true"
                :streamDetails="streamDetails"
                :customVideoId="videoId"
                :videoPlayer="videoPlayerUrl"
                :videoHls="video.video_hls"
              />
            </v-card>
            <v-card
              v-if="isStreamingRightNow && value === 1"
              flat
              tile
              class="d-flex flex-column"
            >
              <live-metrics
                :isStreamingRightNow="isStreamingRightNow"
                :serverStatus="serverStatus"
                :liveStatus="liveStatus"
                :timeLeft="timeLeft"
                :errors="errors"
                :liveInfo="liveInfo"
                :lastVerificationServer="lastVerificationServer"
                :viewers="viewers"
                :isLive="true"
                :streamDetails="streamDetails"
                :videoPlayer="videoPlayerUrl"
                :videoHls="video.video_hls"
              />
            </v-card>
          </v-scroll-x-transition>

          <div class="d-grid">
            <span>{{ $t('message.pages.live.attending') }}</span>
            <!-- <span v-if="viewers === 0">-</span> -->
            <span
              v-if="isOnline"
              style="color: var(--v-primary-base)"
              class="text-h6"
              >{{ viewers }}</span
            >
            <span v-if="!isOnline">-</span>
          </div>

          <div class="d-grid">
            <span>{{ $t('message.pages.live.frameRate') }}</span>
            <span
              v-if="isOnline"
              style="color: var(--v-primary-base)"
              class="text-h6"
              >{{ height }}p/{{ framerate }}fps</span
            >
            <span v-if="!isOnline">-</span>
          </div>

          <div class="d-grid">
            <span> Kbps </span>
            <span
              v-if="isOnline"
              :class="{
                'text-h6': true,
                'green-text': liveKbps > 2500,
                'orange-text': liveKbps <= 2500 && liveKbps > 2100,
                'red-text': liveKbps <= 2100,
              }"
            >
              {{ liveKbps }}
            </span>
            <span v-if="!isOnline">-</span>
          </div>

          <div class="d-grid">
            <span>{{ $t('message.pages.live.averageTime') }}</span>

            <!-- <span v-if="isOnline" style="color: var(--v-primary-base);" class="text-h6"> {{ timeCounter }}</span> -->
            <span
              v-if="isOnline"
              style="color: var(--v-primary-base)"
              class="text-h6"
            >
              {{ timeCounter }}
            </span>
            <span v-if="!isOnline">-</span>
          </div>
        </div>
      </div>
    </template>
  </page-view>
</template>

<script>
// external imports

import { mapState, mapMutations } from 'vuex'
import _ from 'lodash'
import CountDown from 'count-time-down'

// internal imports
import liveService from '@/services/liveServiceV2'
import liveMixin from '@/utils/liveV2.mixin.js'
import Storage from '@/utils/Storage'
import { PRICE_ID_GOLD } from '@/config/envs'
import embedPageMixin from '@/utils/embedPage.mixin.js'
import i18n from '@/translations/lang'

// API
import planApi from '@/services/planApi'
import videosApi from '@/services/videosApi'
import profileApi from '@/services/profileApi'

// Components
import PageView from '@/layout/PageView.vue'

export default {
  name: 'NewTestV2',
  components: {
    PageView,
    BaseHeader: () => import('@/components/BaseHeader.vue'),
  },
  mixins: [liveMixin, embedPageMixin],
  provide() {
    return {
      // computed
      isPlanGold: this.isPlanGold,
      notCreated: this.notCreated,
      isOnline: this.isOnline,

      // methods
      openRestreamModal: this.openRestreamModal,
      handleSaveName: this.handleSaveName,
    }
  },
  data: () => ({
    videoId: '',
    video: {
      title: '',
    },
    peakViews: 0,
    isAfterScheduled: false,
    timeCounter: '',
    countDown: '',
    startTime: '00:00:00',
    timeVideo: 0,
    oldVideo: {},
    loading: true,
    time: 0,
    liveBytesIn: 0,
    framerate: 0,
    height: 0,
    created_at: '',
    started_at: '',
    timeToStart: '00:00:00',
    scheduled_at: '',
    liveKbps: 0,
    previousBytes: 0,
    liveTimerInterval: null,
    previousTime: 0,
    streamDetails: {},
    hoursMinutes: [],
    isTimingDown: false,
    allHoursMinutes: [],
    formattedDate: '',
    scheduleDate: null,
    selectedHour: null,
    defaultBitrate: 'Original',
    avalibleBitrates: [],
    prices: {},
    qualitiesToMakeAvailable: ['240p', '360p', '480p', '720p'],
    currency: '',
    currencyLocale: '',
    activeDvr: true,
    folder: {
      folder_id: null,
      folder_name: '',
    },
    liveStatus: '',
    liveInfo: {},
    liveIsDone: false,
    errors: {
      failedToUpdateVideo: false,
      videoDoesNotExist: false,
    },
    stream_key_id: null,
    isLive: false,
    counterInterval: null,
    serverTime: null,
    current_time: null,
  }),
  computed: {
    ...mapState('user', {
      userPlanInfo: 'userPlanInfo',
    }),
    aside() {
      return [
        {
          title: i18n.t('message.routesTitles.Settings'),
          icon: 'mdi-cog',
          component: () => import('./Settings/index.vue'),
          props: this.$data,
        },
        {
          title: 'Embed',
          icon: 'mdi-link-variant',
          component: () => import('./Embed/index.vue'),
          props: this.$data,
        },
        {
          title: 'Chat',
          icon: 'mdi-message',
          component: () => import('./Chat/index.vue'),
          props: this.$data,
        },
        {
          title: i18n.t('message.routesTitles.Metrics'),
          icon: 'mdi-chart-box-outline',
          component: () => import('./Metrics/index.vue'),
          props: this.$data,
        },
      ]
    },
    isPlanGold() {
      return _.isEqual(PRICE_ID_GOLD, this.userPlanInfo.subscription?.price_id)
    },
    hasVideoID() {
      return !!this.videoId
    },
    selectedDateTime() {
      if (this.selectedHour === null || this.scheduleDate === null) {
        return null
      }

      const [hour, minute] = this.selectedHour.split(':')

      let date = Date.parse(`${this.scheduleDate} 00:00`)
      date = new Date(date)

      date.setHours(parseInt(hour, 10))
      date.setMinutes(parseInt(minute, 10))

      return date
    },
    isStreamingRightNow() {
      return !this.hasVideoID
    },
    isPlayerLiveState() {
      return !this.hasVideoID || this.video.status !== 'CONVERTED'
    },
    isConverting() {
      const { status } = this.video
      return (
        (status === 'CONVERTING' ||
          status === 'FAILED' ||
          status === 'DRAFT') &&
        !this.isPlayerLiveState
      )
    },
    isOnline() {
      const { liveStatus } = this
      return liveStatus === 'online'
    },
    isOffline() {
      const { liveStatus } = this
      return liveStatus === 'offline'
    },
    notCreated() {
      const { liveStatus } = this
      return liveStatus === ''
    },
  },
  watch: {
    avalibleBitrates() {
      Storage.setItem('liveBitrates', this.avalibleBitrates)
    },
    startTime: function () {
      let time = this.startTime.split(':')
      let seconds = +time[0] * 60 + +time[1]
      if (this.timeVideo >= 3600) {
        if (time.length === 2) {
          seconds = +time[0] * 60 + +time[1]
        } else if (time.length === 1) {
          seconds = +time[0]
        } else {
          seconds = +time[0] * 60 * 60 + +time[1] * 60 + +time[2]
        }
      } else {
        if (time.length === 1) {
          seconds = +time[0]
        }
      }
      if (seconds > this.timeVideo) {
        this.embedVideo.startTime = this.timeVideo
        this.startTime = this.formatTime(this.timeVideo, 'startTime')
      }
      this.embedVideo.startTime = seconds
    },
  },
  async created() {
    await this.fetchData()

    this.$root.streamUrl = this.streamUrl
    this.$root.streamHls = this.streamHls
    this.$root.streamKey = this.streamKey

    this.fetchRestreams()
    this.fetchRestreamsInterval = setInterval(() => {
      this.fetchRestreams()
    }, 10000)
  },
  async mounted() {
    await this.getLiveInfo()
    const script = document.createElement('script')
    script.src = 'https://player.pandavideo.com.br/api.js'
    script.async = true
    document.body.appendChild(script)

    window.onPandaPlayerApiLoad = () => {
      // eslint-disable-next-line no-undef
      this.player = new PandaPlayer('panda-player', {
        onReady: () => {
          this.setCounter()
        },
      })
    }

    window.onPandaPlayerApiLoad()

    this.loadRootOn(true)
    this.setScheduledCounter()
    this.setAllHoursMinutes()
    this.formatDate(this.scheduled_at)

    this.isLive = true
    this.isBeta = location.search.match('beta')

    if (this.liveStatus === 'online') {
      await this.fetchRestreams()
    }

    if (!this.$route.params.id) {
      this.setCurrencyConfig()
      await this.setQualitiesPrices()
    }

    document.addEventListener('visibilitychange', this.handleVisibilityChange)
  },
  beforeDestroy() {
    document.removeEventListener(
      'visibilitychange',
      this.handleVisibilityChange
    )
    this.loadRootOn(false)
    this.isLive = false
    clearInterval(this.liveTimerInterval)
    clearInterval(this.fetchRestreamsInterval)
    clearInterval(this.checkViewers)
    clearInterval(this.counterInterval)
  },
  methods: {
    ...mapMutations('video', ['UPDATE_VIDEO_PROFILE']),
    loadRootOn(isToLoad) {
      if (isToLoad) {
        this.$root.$on('selected-live-stream-key', (id) => {
          this.stream_key_id = id
        })
      } else {
        this.$root.$off('selected-live-stream-key')
      }
    },

    handleOpenVideo() {
      this.$router.push({ name: 'VideoPage', params: { id: this.videoId } })
    },

    handleVisibilityChange() {
      if (document.hidden) {
        cancelAnimationFrame(this.counterInterval)
      } else {
        this.updateTimeCounter()
        this.counterInterval = requestAnimationFrame(this.updateCounter)
      }
    },

    scheduledCheck() {
      let currentTime = new Date()
      let scheduledTime = new Date(this.scheduled_at)

      if (currentTime > scheduledTime) {
        this.isAfterScheduled = true
        this.$root.$emit('isAfterScheduledTrue')
      }
    },

    setCurrencyConfig() {
      const { currency } = this.userPlanInfo

      this.currency = 'brl'
      this.currencyLocale = 'pt-BR'

      if (currency === 'usd') {
        this.currency = 'usd'
        this.currencyLocale = 'en-US'
      }
    },
    async getLiveInfo() {
      const response = await liveService.getLive(this.$route.params.id)
      this.scheduledCheck()

      this.created_at = response.data.created_at
      this.scheduled_at = response.data.scheduled_at
      this.liveStatus = response.data.status
      this.videoId = response.data.video_id
      this.current_time = response.data.current_time
      this.activeDvr = response.data.active_dvr

      this.handleShowReastream()

      if (this.liveStatus === 'online') {
        this.started_at = response.data.started_at
        if (this.timeCounter === '') {
          this.lastDuration = null
          this.lastUpdateTime = Date.now()
          this.setCounter()
        }
      }

      this.$emit('live-scheduled-at-updated', this.scheduled_at)
    },
    async handleShowReastream() {
      if (!this.scheduled_at) {
        this.$root.$emit('handleRestream', true)
        return
      }
      if (this.liveStatus === 'finished') {
        this.$root.$emit('handleRestream', false)
        return
      }
      const currentTime = new Date(this.current_time).getTime()
      const scheduleTime = new Date(this.scheduled_at).getTime()

      if (scheduleTime <= currentTime) {
        this.$root.$emit('handleRestream', true)
      } else {
        this.$root.$emit('handleRestream', false)
      }
    },
    async startLive() {
      await liveService.initLive(this.$route.params.id)

      this.isAfterScheduled = true
      this.$root.$emit('liveStarted') // Emitir evento de live iniciada
    },

    async fetchRestreams() {
      if (!this.$route.params.id) return
      if (this.liveStatus === 'online') {
        const { data } = await liveService.getInfoHost(this.$route.params.id)
        this.liveBytesIn = data.ret.bytes_in

        this.framerate = data.ret.meta.video.frame_rate
        this.height = data.ret.meta.video.height
        this.time = data.ret.time

        this.getLiveInfo()
        this.calculateKbps(this.liveBytesIn, this.time)
      } else {
        this.getLiveInfo()
      }
    },

    calculateKbps(liveBytesIn, time) {
      let kbps = null

      if (this.previousTime === null) {
        this.previousBytes = liveBytesIn
        this.previousTime = time
      } else {
        const deltaBytes = liveBytesIn - this.previousBytes
        const deltaTime = (time - this.previousTime) / 1000 // Convert to seconds
        const deltaBits = deltaBytes * 8

        kbps = parseInt(deltaBits / deltaTime / 1000, 10)
      }

      this.previousBytes = liveBytesIn
      this.previousTime = time

      this.liveKbps = kbps
    },

    setScheduledCounter() {
      const intervalId = setInterval(() => {
        const currentTime = new Date().getTime()
        const scheduledTime = new Date(this.scheduled_at).getTime()
        const timeDifference = scheduledTime - currentTime

        if (timeDifference <= 0) {
          clearInterval(intervalId)
          this.timeToStart = '00:00:00'
        } else {
          const hours = Math.floor(timeDifference / (1000 * 60 * 60))
          const minutes = Math.floor(
            (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
          )
          const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000)

          this.timeToStart = `${hours.toString().padStart(2, '0')}:${minutes
            .toString()
            .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
        }
      }, 1000)
    },

    updateTimeCounter() {
      const now = Date.now()
      const elapsedTime = (now - this.lastUpdateTime) / 1000

      if (elapsedTime >= 4) {
        const duration = this.player.getDuration()
        if (!this.activeDvr || duration > 0) {
          if (this.activeDvr) {
            this.lastDuration = duration
            this.lastUpdateTime = now
          } else {
            if (this.lastDuration === null || elapsedTime >= 10) {
              let currentTime = Date.parse(this.current_time)
              let startedAt = Date.parse(this.started_at)
              let differenceInSeconds = (currentTime - startedAt) / 1000
              this.lastDuration = differenceInSeconds
              this.lastUpdateTime = now
            }
          }
        }
      }

      if (this.lastDuration === null) {
        this.timeCounter = '-'
      } else {
        const currentDuration =
          this.lastDuration + (now - this.lastUpdateTime) / 1000

        const totalSeconds = Math.floor(currentDuration)

        if (!isNaN(totalSeconds)) {
          const hours = Math.floor(totalSeconds / 3600)
          const minutes = Math.floor((totalSeconds % 3600) / 60)
          const seconds = totalSeconds % 60

          const pad = (val) => (val > 9 ? val : '0' + val)

          this.timeCounter = `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
        }
      }
    },

    setCounter() {
      this.counterInterval = setInterval(() => {
        this.updateTimeCounter()
      }, 1000)
    },

    formatDate(scheduleAt) {
      const date = new Date(scheduleAt)

      const day = ('0' + date.getDate()).slice(-2)
      const month = ('0' + (date.getMonth() + 1)).slice(-2)
      const year = date.getFullYear()

      const hours = ('0' + date.getHours()).slice(-2)
      const minutes = ('0' + date.getMinutes()).slice(-2)

      this.formattedDate = `${day}/${month}/${year} - ${hours}h${minutes}`
    },
    setTimeDown(time) {
      let cd = new CountDown(
        time,
        { autoStart: true },
        function () {
          this.countDown = `- ${cd.mmss}`
        }.bind(this)
      )
      cd.start()
    },
    setAllHoursMinutes() {
      for (let i = 0; i < 24; i++) {
        for (let j = 0; j < 60; j += 10) {
          let hour = i < 10 ? '0' + i : i
          let minute = j < 10 ? '0' + j : j
          this.allHoursMinutes.push(`${hour}:${minute}`)
        }
      }
      this.avalibleBitrates = Storage.getItem('liveBitrates') ?? []
    },
    formatTime(seconds, type) {
      const h = Math.floor(seconds / 3600)
      const m = Math.floor((seconds % 3600) / 60)
      const s = Math.round(seconds % 60)
      if (type) {
        0
        if (this.timeVideo >= 3600) {
          return [
            h > 9 ? h : h ? '0' + h : '0' + h || '00',
            m > 9 ? m : h ? '0' + m : '0' + m || '00',
            s > 9 ? s : '0' + s,
          ]
            .filter(Boolean)
            .join(':')
        } else {
          return [
            m > 9 ? m : h ? '0' + m : '0' + m || '00',
            s > 9 ? s : '0' + s,
          ]
            .filter(Boolean)
            .join(':')
        }
      }
      return [
        h > 9 ? h : h ? '0' + h : '0' + h || '00',
        m > 9 ? m : h ? '0' + m : '0' + m || '00',
        s > 9 ? s : '0' + s,
      ]
        .filter(Boolean)
        .join(':')
    },
    async setQualitiesPrices() {
      const hasText = (text, str) => !!~text.indexOf(str)

      const qualities = this.qualitiesToMakeAvailable
      const options = {
        style: 'currency',
        currency: this.currency,
      }

      const { data: livePrices } = await planApi.getPlans(
        this.userPlanInfo.currency
      )

      for (const addon of livePrices.addons) {
        for (const quality of qualities) {
          if (hasText(addon.name, quality)) {
            const amount = addon.prices[0].unit_amount / 100
            const localeAmount = amount.toLocaleString(
              this.currencyLocale,
              options
            )

            this.$set(this.prices, quality, localeAmount)
          }
        }
      }
    },
    async handleCreateLive() {
      if (this.stream_key_id === null)
        return alert('Please select a key before proceeding')

      const bitrate = this.avalibleBitrates.length
        ? this.avalibleBitrates
        : undefined

      const dataCreate = {
        title: this.video.title,
        bitrate,
        active_dvr: this.activeDvr,
        stream_key_id: this.stream_key_id,
      }

      if (this.folder.folder_id) {
        dataCreate['folder_id'] = this.folder.folder_id
      }

      if (this.selectedDateTime) {
        const date = this.selectedDateTime.toISOString()
        dataCreate.scheduled_at = date.replace('Z', '')
      }

      try {
        const { data } = await liveService.createLive(dataCreate, false)

        this.$root.streamUrl = data.streamUrl
        this.$root.streamKey = data.streamKey

        this.$router.push({
          name: 'NewLiveV2Edit',
          params: { id: data.id },
        })
      } catch (e) {
        console.error(e)
        this.errors.failedToUpdateVideo = true
      } finally {
        this.loadings.createLive = false
      }
    },

    async loadLiveData() {
      await this.fetchData() // mixin

      try {
        const videoInfo = await videosApi.getAVideo(this.videoId)
        const videoProfileId = videoInfo.data.config.profile

        if (videoProfileId) {
          const { data } = await profileApi.getProfileId(videoProfileId)
          this.UPDATE_VIDEO_PROFILE(data)
        }
      } catch (e) {
        console.error(e)
      }
      if (!window.db) this.$root.$emit('initDexie')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/src/new-live';

::v-deep {
  @import '@/assets/scss/src/new-live';

  .v-text-field fieldset,
  .v-text-field .v-input__control {
    border-color: var(--v-neutral-lighten2);
    color: var(--v-neutral-base);
  }
}

.v-btn {
  text-transform: none;
  line-height: 16px;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: normal;
}

.green-text {
  color: green;
}

.orange-text {
  color: orange;
}

.red-text {
  color: red;
}

.page-view__aside {
  width: 300px;
  /* ... outros estilos ... */
}

.player-content {
  border: 2.5px dashed var(--v-brand-lighten2);
  border-radius: 8px;
}

.page-label-title {
  margin-bottom: $spacing-minus-2;

  display: block;

  font: {
    family: Rubik;
    size: 20px;
    weight: 500;
  }

  line-height: 24px;
  letter-spacing: 0px;
  text-align: center;
  color: var(--v-neutral-lighten1);
}

.circle {
  margin-right: 5px;
  margin-top: 0.3px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: red;
  display: inline-block;
}

.page-label-text {
  margin-bottom: $spacing-minus-2;

  display: block;

  font: {
    family: Rubik;
    size: 14px;
    weight: 400;
  }

  line-height: 21px;
  letter-spacing: 0px;
  text-align: center;
  color: var(--v-neutral-lighten1);
}

@media only screen and (min-width: 1550px) {
  .is-streaming {
    display: block;
    height: 401.13px;
    width: 713.13px;
  }
  .new-live {
    &__container {
      width: 715px;
      height: 511px;
    }
    &__player {
      &.is-waiting {
        max-height: 410px;
      }
    }
  }
}

@media only screen and (min-width: 1940px) {
  .is-streaming {
    display: block;
    height: 495.13px;
    width: 883.13px;
  }
  .new-live {
    &__container {
      width: 883.28px;
      height: 595px;
    }
    &__player {
      &.is-waiting {
        max-height: 491.58px;
      }
    }
  }
}
.new-live {
  &__container {
    margin: 0 auto;
    max-width: 500px;
    background: var(--v-neutral-lighten4);
    border-radius: 4px;
    border: 1px solid var(--v-brand-lighten2);
    overflow: hidden;
    position: relative;
  }

  &__player {
    position: relative;
    display: block;
    padding-top: 56.25%;
    border: 1px solid var(--v-neutral-lighten3);
    background: var(--v-neutral-lighten2);

    &.is-waiting {
      padding-top: 0;
      height: calc(34vw - 34px);
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      position: relative;

      .player-text {
        text-align: center;
        margin: 0;
        font-size: 1rem;
        color: red;
      }
    }
  }

  &__data {
    display: flex;
    height: 100px;
    padding: $spacing-plus-3;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    font-size: 0.875rem;
    color: var(--v-neutral-lighten1);

    &--status {
      display: flex;
      align-items: center;
      justify-content: center;
      text-transform: uppercase;
    }
  }
}

.d-grid {
  display: grid;
}

// .page-view__aside {
//   background-color: red !important;
//   padding-left: -40px !important;
// }

.page-view__content {
  max-width: 500px !important;
}

.bg-dark {
  .page-view__aside--nav {
    background-color: var(--v-neutral-lighten4);
  }

  .new-live {
    &__container {
      border: 1px solid var(--v-neutral-darken1);
    }
  }

  .new-live__container {
    background-color: var(--v-neutral-darken2);
  }

  .d-grid {
    color: var(--v-blueMarine-base);
  }

  .offlineStatus {
    background-color: red;
  }
}
</style>
